import * as React from "react";
import { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid, Paper, useTheme } from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";
import install from "../sharedCode/install.png";
import { isLandscape } from "../Utils/UtilityMethods";

const { setTimeout, clearTimeout } = window;

const FORM_COUNT = 2;
const DELAY = 15000;
const MAX_CYCLES = 3;

type State = {
    formIndex: number;
    displayCycle: number;
    finished: boolean;
};

export default function InstallationPrompter(): JSX.Element {
    const theme = useTheme();
    const [state, setState] = useState<State>({ formIndex: 0, displayCycle: 0, finished: false });

    useEffect(() => {
        let timerId: number | undefined;
        if (state.displayCycle < MAX_CYCLES) {
            timerId = setTimeout(() => {
                setState((prev) => {
                    const newFormIndex = state.formIndex + 1;
                    if (newFormIndex >= FORM_COUNT) {
                        return { formIndex: 0, displayCycle: prev.displayCycle + 1, finished: prev.finished };
                    }
                    return { formIndex: newFormIndex, displayCycle: prev.displayCycle, finished: prev.finished };
                });

                timerId = undefined;
            }, DELAY);
        } else if (!state.finished) {
            setState((prev) => {
                return { formIndex: 1, displayCycle: MAX_CYCLES + 1, finished: true };
            });
        }

        return () => clearTimeout(timerId);
    }, [state]);

    // less height in landscape so have to keep the image narrower
    const maxWidth = isLandscape(theme) ? "35%" : "60%";
    const itemHeight = 42;

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "top",
                height: "100vh",
            }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                    maxWidth,
                }}>
                <Paper
                    sx={{
                        p: 3,
                        borderRadius: 1,
                        textAlign: "center",
                        boxShadow: 2,
                    }}>
                    {state.formIndex === 0 && (
                        <Grid container flexDirection={"column"} alignItems={"flex-start"}>
                            <Grid item sx={{ pb: 4 }}>
                                <Typography variant="h6" color={theme.palette.error.main}>
                                    ADD APP TO HOME SCREEN
                                </Typography>
                            </Grid>
                            <Grid item container alignItems={"center"} sx={{ height: itemHeight }}>
                                <Grid item>
                                    <Typography color={theme.palette.primary.main}>1 - TAP THE SHARE ICON</Typography>
                                </Grid>
                                <Grid item sx={{ pl: 2 }}>
                                    <IosShareIcon style={{ color: "cornflowerblue" }} />
                                </Grid>
                            </Grid>
                            <Grid item container alignItems={"center"} sx={{ height: itemHeight }}>
                                <Typography color={theme.palette.primary.main}>2 - SCROLL UP AND TAP ADD TO HOME SCREEN</Typography>
                            </Grid>
                        </Grid>
                    )}
                    {state.formIndex === 1 && (
                        <Grid container flexDirection={"column"}>
                            <Grid item container alignItems={"center"} justifyContent={"center"}>
                                <img
                                    src={install}
                                    alt={"ios installation"}
                                    style={{
                                        maxWidth: "100%", // Constrain the image to the width of its container
                                        height: "auto", // Maintain aspect ratio
                                    }}
                                />
                            </Grid>
                        </Grid>
                    )}
                </Paper>
            </Box>
        </Box>
    );
}
